/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../components/MainBody/MainBody";
import MainTabList from "../../components/MainBody/MainTabList";
import EditOrganization from "./EditOrganization";
import PricingPlans from "../Subscription/PricingPlans";
import CurrentSubscription from "../Subscription/CurrentSubscription";
import CardDetail from "../Subscription/CardDetail";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_PUBLISHABLE_KEY } from "../../config";
import { Elements } from "@stripe/react-stripe-js";
import TemplateSettings from "../TrustGeneralSettings/TemplateSettings/TemplateSettings";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { useUser } from "../../lib/context/UserContext";
import { AMLCTFModuleConditonIndustry } from "../../lib/PermissionConditions";

const GeneralSetting = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "entity";

  const { organizationData } = useOrganization();

  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  let tabsKey = [
    {
      name: "Entity",
      tabName: "entity",
      value: 1,
    },
    {
      name: "Subscription Details",
      tabName: "subscription-details",
      value: 3,
    },
    {
      name: "Subscription",
      tabName: "subscription",
      value: 2,
    },
    {
      name: "Card Details",
      tabName: "card-details",
      value: 4,
    },
  ];

  if (amlCTFEnable) {
    tabsKey.push({
      name: "Template Settings",
      tabName: "template-settings",
      value: 5,
    });
  }
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;
  const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const navigate = useNavigate();

  useEffect(() => {
    navigate(
      `/general-settings?tab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab]);

  return (
    <>
      <MainBody search={false} loading={false}>
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background ${activeTab === 2 ? "p-0" : ""}`}
        >
          {activeTab === 1 ? (
            <EditOrganization />
          ) : activeTab === 2 ? (
            <PricingPlans expandList={true} />
          ) : activeTab === 3 ? (
            <CurrentSubscription expandList={true} />
          ) : activeTab === 4 ? (
            <Elements stripe={stripePromise}>
              <CardDetail expandList={true} />
            </Elements>
          ) : activeTab === 5 ? (
            <Elements stripe={stripePromise}>
              <TemplateSettings org={true} />
            </Elements>
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default GeneralSetting;
